import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Grid } from "@mui/material";

const MuiResponsivePhoneInputControlled = ({ userData, setMobile }) => {
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (userData?.country_code && userData?.mobile_number) {
      const fullNumber = `+${userData.country_code}${userData.mobile_number}`;
      setPhone(fullNumber);
    }
  }, [userData]);

  // Handle dropdown tracking
  useEffect(() => {
    const interval = setInterval(() => {
      const dropdown = document.querySelector(".country-list");
      setIsDropdownOpen(dropdown && dropdown.offsetParent !== null);
    }, 200);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (val, data) => {
    const numberOnly = val.replace(`+${data.dialCode}`, "").replace(/\D/g, "");
    setPhone(val);
    setMobile({
      full: val,
      dialCode: data.dialCode,
      number: numberOnly,
    });
  };

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={11}
      sx={{
        overflow: "visible",
        transition: "height 0.5s ease",
        minHeight: isDropdownOpen ? "35vh" : "auto",
      }}
      ref={containerRef}
    >
      <PhoneInput
        country={countryCode}
        enableSearch
        value={phone}
        onChange={handleChange}
        inputStyle={{
          width: "100%",
          height: "42px",
          fontSize: "0.8rem",
          borderRadius: "4px",
        }}
        dropdownStyle={{
          width: "30vw",
          zIndex: 9999,
        }}
        buttonStyle={{
          height: "42px", // ✅ Match height
          borderTopLeftRadius: "4px",
          borderBottomLeftRadius: "4px",
        }}
        searchStyle={{
          width: "25vw",
          zIndex: 9999,
        }}
        inputProps={{
          name: "phone",
          required: true,
          autoFocus: true,
          autoComplete: "off",
        }}
        sx={{
          "& .MuiInputLabel-root": {
            fontSize: "0.8rem",
          },
          "& .MuiInputLabel-shrink": {
            fontSize: "1rem",
          },
        }}
      />
    </Grid>
  );
};

export default MuiResponsivePhoneInputControlled;
